"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectDeployPreview = selectDeployPreview;
exports.default = void 0;

var _immutable = require("immutable");

var _deploys = require("../actions/deploys");

function deploys(state = (0, _immutable.Map)({
  deploys: (0, _immutable.Map)()
}), action) {
  switch (action.type) {
    case _deploys.DEPLOY_PREVIEW_REQUEST:
      {
        const {
          collection,
          slug
        } = action.payload;
        return state.setIn(['deploys', `${collection}.${slug}`, 'isFetching'], true);
      }

    case _deploys.DEPLOY_PREVIEW_SUCCESS:
      {
        const {
          collection,
          slug,
          url,
          status
        } = action.payload;
        return state.setIn(['deploys', `${collection}.${slug}`], (0, _immutable.fromJS)({
          isFetching: false,
          url,
          status
        }));
      }

    case _deploys.DEPLOY_PREVIEW_FAILURE:
      {
        const {
          collection,
          slug
        } = action.payload;
        return state.setIn(['deploys', `${collection}.${slug}`], (0, _immutable.fromJS)({
          isFetching: false
        }));
      }

    default:
      return state;
  }
}

function selectDeployPreview(state, collection, slug) {
  return state.getIn(['deploys', `${collection}.${slug}`]);
}

var _default = deploys;
exports.default = _default;